import { hasLineItemTypes } from './has-line-item-types.js';

const createContainsHelper = (lineItems)=>{
    return {
        get contactLenses () {
            return hasLineItemTypes(lineItems, [
                'contact-lenses'
            ]);
        },
        get contactLensesSubscription () {
            return hasLineItemTypes(lineItems, [
                'contact-lenses-subscription'
            ]);
        },
        get prescriptionGlasses () {
            return hasLineItemTypes(lineItems, [
                'prescription-glasses'
            ]);
        },
        get solutions () {
            return hasLineItemTypes(lineItems, [
                'solutions'
            ]);
        },
        get sunglasses () {
            return hasLineItemTypes(lineItems, [
                'sunglasses'
            ]);
        },
        get subscription () {
            return hasLineItemTypes(lineItems, [
                'contact-lenses-subscription',
                'contact-lenses-bundle-benelux', 
            ]);
        }
    };
};

export { createContainsHelper };
//# sourceMappingURL=create-contains-helper.js.map
